import React, { useState } from 'react';
import { TrashIcon, PlusIcon } from '../../../components/Icons';

interface PropertyImageGalleryEditorProps {
  images: string[];
  onChange: (images: string[]) => void;
}

export const PropertyImageGalleryEditor: React.FC<PropertyImageGalleryEditorProps> = ({ images, onChange }) => {
  const [newImageUrl, setNewImageUrl] = useState('');

  const addImage = () => {
    if (!newImageUrl.trim()) return;
    onChange([...images, newImageUrl.trim()]);
    setNewImageUrl('');
  };

  const removeImage = (idx: number) => {
    onChange(images.filter((_, i) => i !== idx));
  };

  return (
    <div id="admin-image-gallery-editor">
      <label className="font-bold text-gray-700 block mb-1">Galería de Imágenes (URLs)</label>
      <div className="flex gap-2 mb-2">
        <input
          id="admin-image-url-input"
          type="url"
          value={newImageUrl}
          onChange={(e) => setNewImageUrl(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addImage())}
          placeholder="https://..."
          className="flex-grow p-2 border rounded-lg"
        />
        <button
          id="admin-image-add-btn"
          type="button"
          onClick={addImage}
          className="px-3 py-1 bg-sky-600 hover:bg-sky-700 text-white rounded-lg font-bold transition-colors"
        >
          <PlusIcon className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2 max-h-32 overflow-y-auto p-2 bg-gray-50 rounded-lg border border-gray-100">
        {images.map((url, idx) => (
          <div key={`${url}-${idx}`} className="relative group rounded border bg-white overflow-hidden aspect-video">
            <img src={url} alt={`img-${idx}`} className="w-full h-full object-cover" referrerPolicy="no-referrer" />
            <button
              type="button"
              onClick={() => removeImage(idx)}
              className="absolute top-1 right-1 p-1 bg-red-600 text-white rounded opacity-80 hover:opacity-100 transition-opacity"
              title="Eliminar imagen"
            >
              <TrashIcon className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
